export const appRoutes = {
    login: '/users/login',
    payment: 'users/payment',
    forbidden: '/pages/403',
    notFound:'app/not-found',
    dashboard: 'users/dashboard',
    getStarted: 'users/get-started',
    choosePlan: 'users/choose-plan',
    landingPage: 'users/landing-page'
}